import { analyzeFile, type FileView } from "./parse.js";

export * from "./parse.js";
export * from "./map.js";
export * from "./notes.js";
export * from "./launch.js";
export * from "./lineage.js";
export { addRunCounters } from "./trace.js";
export * from "./timelapse.js";

/** Every JavaScript file in the project, in a stable order (game.js first). */
export function analyzeProject(files: Record<string, string>): FileView[] {
  return Object.keys(files)
    .filter((f) => f.endsWith(".js"))
    .sort((a, b) => (a === "game.js" ? -1 : b === "game.js" ? 1 : a.localeCompare(b)))
    .map((f) => analyzeFile(f, files[f]!));
}
